import React from 'react';
import '../styles/StickyWhatsAppButton.css'; 
import { FaWhatsapp } from 'react-icons/fa'; 

const StickyWhatsAppButton = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;

  return (
    <a
    href={whatsappLink}
      className="sticky-whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default StickyWhatsAppButton;
